import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { agentAuthAPI } from '../../services/agentAuthAPI';
import { handleApiError } from '../../utils/helpers';
import LoadingSpinner from '../common/LoadingSpinner';
import './AgentLogin.css';

const AgentLogin = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Check if already logged in (avoid redirect loop)
  const [shouldRedirect, setShouldRedirect] = useState(false);
  useEffect(() => {
  const token = sessionStorage.getItem('agentToken');
    if (token) {
      setShouldRedirect(true);
    }
  }, []);

  if (shouldRedirect) {
    return <Navigate to="/agent/dashboard" />;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
    const response = await agentAuthAPI.login(credentials);
    // Store only token
  sessionStorage.setItem('agentToken', response.data.token);
    // Trigger redirect after login
    setShouldRedirect(true);
      
    } catch (error) {
      setError(handleApiError(error));
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="agent-login-container">
      <div className="login-card">
        <div className="login-header">
          <h2>Agent Portal Login</h2>
          <p>Enter your credentials to access the tracking system</p>
        </div>

        {error && (
          <div className="alert alert-error">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="username">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              value={credentials.username}
              onChange={handleChange}
              required
              disabled={loading}
              placeholder="Enter your username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              required
              disabled={loading}
              placeholder="Enter your password"
            />
          </div>

          <button 
            type="submit" 
            className="btn btn-primary login-btn"
            disabled={loading}
          >
            {loading ? <LoadingSpinner size="small" text="" /> : 'Login'}
          </button>
        </form>

        <div className="login-footer">
          <p>Need help? Contact your system administrator</p>
        </div>
      </div>
    </div>
  );
};

export default AgentLogin;